import React from 'react';

import { useStateContext } from '../context/AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

function RouteProtected({ allwedPermissions }) {

    const { user: { permissions } } = useStateContext();
    
    const location = useLocation();

    return (
        permissions && permissions.find(permission => allwedPermissions.includes(permission))
            ? <Outlet /> : <Navigate to="/unauthorized" state={{ from: location }} replace />
    )

}

export default RouteProtected;